module.exports = __webpack_public_path__ + "img/yishi9.f461f0f1.jpg";